import React, {useState, useEffect} from 'react';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
// import "./DatePicker.css";
import ko from 'date-fns/locale/ko';    // 한글 라이브러리

registerLocale("ko", ko);

export function CustomDatePicker({startDate, selectedDateHandler}) {
    // 달력 날짜 변경 시 기준점이 되는 날짜
    //   // https://reactdatepicker.com/ 참고
    //  const ExampleCustomInput = ({ value, onClick }) => (
    //          <button class="example-custom-input" onClick={onClick}> {value} </button> );
    // 월/일
    // const getFormattedDate = (date) => { const month = date.toLocaleDateString('ko-KR', { month: 'long', });
    // const day = date.toLocaleDateString('ko-KR', { day: 'numeric', });
    //     return `${month.substr(0, month.length - 1)}/${day.substr(0, day.length - 1)}`;
    // }
    // 요일 반환
    // const getDayName = (date) => {
    //     return date.toLocaleDateString('ko-KR', { weekday: 'long', }).substr(0, 1);
    // }
    // 날짜 비교시 년 월 일까지만 비교하게끔
    // const createDate = (date) => {
    //     return new Date(new Date(date.getFullYear() , date.getMonth() , date.getDate() , 0 , 0 , 0));
    // }

    const [defaultDate, setDefaultDate] = useState(startDate);

    const handler = (date) => {
        setDefaultDate(selectedDateHandler(date));
    }

    const config = {
        className : 'nv_input'
        , locale : 'ko'
        , selected : startDate // 날짜
        //, minDate : new Date()
        , selectsRange : false
        //, includeDates : [new Date()]
        , onChange : handler // 날짜 설정 콜백 함수
        , popperModifiers : {
            // 모바일 web 환경에서 화면을 벗어나지 않도록 하는 설정
            preventOverflow: {
                enabled: true
            }
        }
        , popperPlacement : 'auth'
    };

    return (
        <DatePicker {...config} dateFormat="yyyy-MM-dd" withPortal />
    );
}

export function DateRangeWithModal({startDate, selectedDateHandler}) {

    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    // const [dateRange, setDateRange] = useState(null);
    // const [startDate] = dateRange;

    const [defaultDate, setDefaultDate] = useState(startDate);

    const handler = (date) => {
        setDefaultDate(selectedDateHandler(date));
    }

    const config = {
        className : 'nv_input'
        , locale : 'ko'
        , selected : startDate // 날짜
        , minDate : new Date()
        , selectsRange : false
        //, includeDates : [new Date()]
        , onChange : handler // 날짜 설정 콜백 함수
        , popperModifiers : {
            // 모바일 web 환경에서 화면을 벗어나지 않도록 하는 설정
            preventOverflow: {
                enabled: true
            }
        }
        , popperPlacement : 'auth'
    };

    return (
        <DatePicker {...config} dateFormat="yyyy-MM-dd" withPortal />
    );
}

export function DateRangeWithModal2({startDate, minDate, selectedDateHandler}) {

    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    // const [dateRange, setDateRange] = useState(null);
    // const [startDate] = dateRange;

    const [defaultDate, setDefaultDate] = useState(startDate);

    const handler = (date) => {
        setDefaultDate(selectedDateHandler(date));
    }

    const config = {
        className : 'nv_input'
        , locale : 'ko'
        , selected : startDate // 날짜
        , minDate : minDate
        , selectsRange : false
        //, includeDates : [new Date()]
        , onChange : handler // 날짜 설정 콜백 함수
        , popperModifiers : {
            // 모바일 web 환경에서 화면을 벗어나지 않도록 하는 설정
            preventOverflow: {
                enabled: true
            }
        }
        , popperPlacement : 'auth'
    };

    return (
        <DatePicker {...config} dateFormat="yyyy-MM-dd" withPortal />
    );
}

export function DateRangeWithModal3({startDate, selectedDateHandler}) {
    const [defaultDate, setDefaultDate] = useState(startDate);

    const handler = (date) => {
        setDefaultDate(selectedDateHandler(date));
    }

    const config = {
        className : 'nv_input'
        , locale : 'ko'
        , selected : startDate // 날짜
        /*, maxDate : new Date(new Date().getFullYear()+'-12-31')*/
        , minDate : new Date()
        , selectsRange : false
        , onChange : handler // 날짜 설정 콜백 함수
        , popperModifiers : {
            // 모바일 web 환경에서 화면을 벗어나지 않도록 하는 설정
            preventOverflow: {
                enabled: true
            }
        }
        , popperPlacement : 'auth'
    };

    return (
        <DatePicker {...config} dateFormat="yyyy-MM-dd" withPortal />
    );
}